(() => {
  if (window.AifufandMysteryGiftAppendInitialized) return;
  window.AifufandMysteryGiftAppendInitialized = true;

  const CART_SECTIONS = ["cart-drawer", "cart-icon-bubble"];
  const GIFT_PROPERTIES = {
    _auto_mystery_gift: "true",
  };

  let giftAddInFlight = false;

  function getConfig() {
    return window.AifufandCartHiddenProducts || {};
  }

  function getVariantId(value) {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : null;
  }

  function getRoutes() {
    return {
      add: window.routes?.cart_add_url || `${window.Shopify?.routes?.root || "/"}cart/add`,
    };
  }

  function getCartData(event) {
    return event?.cartData || event?.detail?.cartData || event?.detail?.parsedState || null;
  }

  function getAddedItems(event) {
    const data = getCartData(event);
    if (!data) return [];
    if (Array.isArray(data.items)) return data.items;
    if (data.id || data.variant_id || data.product_id || data.handle) return [data];
    return [];
  }

  function hasGiftItem(items) {
    const giftVariantId = getVariantId(getConfig().mysteryGiftVariantId);
    if (!giftVariantId) return false;
    return items.some((item) => getVariantId(item.variant_id || item.id) === giftVariantId);
  }

  function isEligibleAddedItem(item, event) {
    const config = getConfig();
    const giftVariantId = getVariantId(config.mysteryGiftVariantId);
    const footCreamVariantId = getVariantId(config.footCreamVariantId);
    const variantId = getVariantId(item.variant_id || item.id || event?.productVariantId);
    const eligibleHandles = new Set(config.eligibleProductHandles || []);

    if (!variantId || variantId === giftVariantId || variantId === footCreamVariantId) return false;
    if (item.final_line_price === 0 || item.final_price === 0 || item.price === 0) return false;
    if (eligibleHandles.size > 0 && item.handle && !eligibleHandles.has(item.handle)) return false;
    if (eligibleHandles.size > 0 && !item.handle) return false;

    return true;
  }

  function shouldAppendGift(event) {
    if (!event || event.source !== "product-form") return false;
    if (!getVariantId(getConfig().mysteryGiftVariantId)) return false;
    const addedItems = getAddedItems(event);
    if (hasGiftItem(addedItems)) return false;
    return addedItems.some((item) => isEligibleAddedItem(item, event));
  }

  function getCurrentProductHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function shouldInjectGiftIntoForm(form) {
    const config = getConfig();
    const giftVariantId = getVariantId(config.mysteryGiftVariantId);
    const eligibleHandles = new Set(config.eligibleProductHandles || []);

    if (!giftVariantId || !form || !/\/cart\/add/.test(form.getAttribute("action") || "")) return false;
    if (!form.querySelector('input[name^="items["]')) return false;
    if (form.querySelector('[data-aifufand-mystery-gift-input="true"]')) return false;
    if (eligibleHandles.size > 0 && !eligibleHandles.has(getCurrentProductHandle())) return false;

    return true;
  }

  function getNextItemsIndex(form) {
    let maxIndex = -1;
    form.querySelectorAll('input[name^="items["]').forEach((input) => {
      const match = input.name.match(/^items\[(\d+)\]/);
      if (match) maxIndex = Math.max(maxIndex, Number(match[1]));
    });
    return maxIndex + 1;
  }

  function appendHiddenInput(form, name, value) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    input.dataset.aifufandMysteryGiftInput = "true";
    form.appendChild(input);
  }

  function injectGiftIntoSubmit(event) {
    const form = event.target?.closest?.("form") || event.target;
    if (!shouldInjectGiftIntoForm(form)) return;

    const index = getNextItemsIndex(form);
    appendHiddenInput(form, `items[${index}][id]`, String(getConfig().mysteryGiftVariantId));
    appendHiddenInput(form, `items[${index}][quantity]`, "1");
    appendHiddenInput(form, `items[${index}][properties][_auto_mystery_gift]`, GIFT_PROPERTIES._auto_mystery_gift);
  }

  async function parseCartMutationResponse(response, label) {
    const text = await response.text();
    let data = {};

    try {
      data = text ? JSON.parse(text) : {};
    } catch (error) {
      if (response.ok) throw new Error(`${label} returned invalid JSON: ${error.message}`);
    }

    if (!response.ok) {
      throw new Error(`${label} failed: ${response.status}`);
    }

    return data;
  }

  async function addGift() {
    const routes = getRoutes();
    const response = await fetch(`${routes.add}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: getConfig().mysteryGiftVariantId,
            quantity: 1,
            properties: GIFT_PROPERTIES,
          },
        ],
        sections: CART_SECTIONS,
        sections_url: window.location.pathname,
      }),
    });

    return parseCartMutationResponse(response, "Mystery Gift add");
  }

  function applyGiftResultToCartData(event, giftResult) {
    const cartData = getCartData(event);
    if (!cartData || !giftResult) return;

    if (giftResult.sections) cartData.sections = giftResult.sections;
    if (typeof giftResult.item_count === "number") cartData.item_count = giftResult.item_count;
    if (Array.isArray(giftResult.items)) cartData.items = giftResult.items;
    if (giftResult.total_price != null) cartData.total_price = giftResult.total_price;
    if (giftResult.items_subtotal_price != null) cartData.items_subtotal_price = giftResult.items_subtotal_price;
  }

  async function appendGiftForProductAdd(event) {
    if (!shouldAppendGift(event)) return;
    if (giftAddInFlight) return;

    giftAddInFlight = true;
    try {
      const giftResult = await addGift();
      applyGiftResultToCartData(event, giftResult);
    } catch (error) {
      console.error("Mystery Gift add failed:", error);
    } finally {
      giftAddInFlight = false;
    }
  }

  function bindGiftAppend() {
    document.addEventListener("submit", injectGiftIntoSubmit, true);

    if (window.subscribe && window.PUB_SUB_EVENTS?.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, appendGiftForProductAdd);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindGiftAppend, { once: true });
  } else {
    bindGiftAppend();
  }

  window.AifufandMysteryGiftSync = {
    sync: () => Promise.resolve(),
    schedule: () => {},
    append: appendGiftForProductAdd,
  };
})();
